import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const SliderBackgroundSelectorContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: row;
  left: 0;
  justify-content: center;
  position: fixed;
  top: ${482 * Screen.widthRatio}px;
  width: ${1512 * Screen.widthRatio}px;
  z-index: 1;
  & > * {
    margin: ${8 * Screen.widthRatio}px;
  }
`;
export default SliderBackgroundSelectorContainer;
